import React from "react";
import RaceCourseLeagueHead from "./RaceCourseLeagueHead";
import RacecourseRow from "./RaceCourseRow";


const Racecourse = ({ raceData }) => {
  const race = raceData?.[0] || []

  const {
    nm = "Racecourse",
    nor = 0,
    co = "Unknown Country",
    runner = [],
  } = race;


  const flagPath = `/assets/images/flags/${co.toLowerCase().replace(/\s/g, "-")}.png`;
  const linkPath = `/race-cards/${nm.toLowerCase().replace(/\s/g, "-")}`;



  return (
    <div className="leg_box">
      <RaceCourseLeagueHead
        nm={nm ? nm : ""}
        nor={nor}
        flag={flagPath}
        link={linkPath}
      />
      <div className="racecourse">
        <div className="racecourse_hd">
          <div className="racecourse_row">
            <div className="rec_col form_num">
              <span className="num">1</span>
              <span className="sr_num">0513</span>
            </div>
            <div className="rec_col">Horse Racing</div>
            {/* <div className="rec_col">Lineage</div> */}
            <div className="rec_col">Age</div>
            <div className="rec_col">Weight</div>
            <div className="rec_col">OR</div>
            <div className="rec_col">Jockey/Trainer</div>
          </div>
        </div>

        <div className="racecourse_bdy">
          {runner?.length > 0 ? (
            runner?.map((horse, index) => (
              <RacecourseRow
                key={horse?.id || index}
                number={index + 1}
                horse={horse}
              />
            ))
          ) : (
            <div className="no_runner">No horses available</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Racecourse;
